import styled from 'styled-components';

const Wrap = styled.aside<{ $flat?: boolean }>`
  border: ${({ $flat, theme }) => ($flat ? 'none' : `1px solid ${theme.colors.gray200}`)};
  background: ${({ $flat, theme }) => ($flat ? 'transparent' : theme.colors.gray050)};
  border-radius: ${({ $flat }) => ($flat ? '0' : '14px')};
  padding: ${({ $flat }) => ($flat ? '0' : '1rem')};
  display: grid;
  gap: 0.6rem;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.65rem;
  flex-wrap: wrap;
`;

const LinkButton = styled.a`
  text-decoration: none;
  border: 1px solid rgba(224, 161, 94, 0.58);
  background: transparent;
  color: #e0a15e;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  font-weight: 700;

  &:hover {
    border-color: rgba(224, 161, 94, 0.85);
    background: rgba(224, 161, 94, 0.08);
  }
`;

type HelpBoxProps = {
  readonly discordUrl?: string;
  readonly phoneNumber?: string;
  readonly flat?: boolean;
};

export default function HelpBox({
  discordUrl = process.env.REACT_APP_PUBLIC_DISCORD_INVITE_URL || 'https://discord.gg/',
  phoneNumber = '+1-520-230-3957',
  flat = false,
}: HelpBoxProps) {
  const phoneHref = `tel:${phoneNumber.replace(/[^\d+]/g, '')}`;
  return (
    <Wrap aria-label="Need help" $flat={flat}>
      <h3 style={{ margin: 0 }}>Need help?</h3>
      <p style={{ margin: 0 }}>
        Talk to our team before checkout if you need package guidance.
      </p>
      <Actions>
        <LinkButton href={discordUrl} target="_blank" rel="noreferrer">
          Join Discord
        </LinkButton>
        <LinkButton href={phoneHref}>Call {phoneNumber}</LinkButton>
      </Actions>
    </Wrap>
  );
}
